import { FileConnectQueueBanner } from '@liscio/common';

import { useFirmViewMode } from 'custom-hooks/useFirmViewMode';
import { useProfileData } from 'fetch-utils/users/user-hooks';
import { fileConnectQueuePath } from 'modules/files/views/FilesPageView/inboxSource';
import { routes } from 'routes';

/**
 * The app-wide FileConnect banner, shown above every sidebar page where its link target (the new
 * Files page) exists: desktop, firm users only.
 */
export const FileConnectBanner = () => {
  const { isMobile } = useFirmViewMode();
  const { isFirmUser } = useProfileData();

  return (
    <FileConnectQueueBanner
      enabled={!isMobile && isFirmUser}
      queueLink={{ to: fileConnectQueuePath(routes.files.link()) }}
    />
  );
};
